import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=30066d56&scoped=true&"
import script from "./RejectModal.vue?vue&type=script&lang=js&"
export * from "./RejectModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=30066d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30066d56",
  null
  
)

export default component.exports